import { call, put } from 'redux-saga/effects';
import { apiGeneral, notify } from 'services';
import { IUpdateRequest } from 'interfaces/update-duck';
import { requestErrorHandler } from 'utils';
import { UpdateRtvActions } from 'store/ducks/settings/rtv';

export function* updateRtvRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/rtv/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateRtvActions.success(data));
    notify('success', 'RTV atualizado com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(UpdateRtvActions.failure(errorMessage));
  }
}
